module.exports = __webpack_public_path__ + "img/BETPLAY.6bde36b5.svg";